import type { ComponentType } from "react";
import {
    Boxes,
    Brain,
    CalendarDays,
    Eye,
    Heart,
    Network,
    Puzzle,
    Receipt,
    Shapes,
    Sparkles,
    Users,
    Video,
    Wrench,
} from "lucide-react";

import ConstellationIcon from "../../../shared/ui/icons/ConstellationIcon";
import MeditationIcon from "../../../shared/ui/icons/MeditationIcon";

/** Any icon the registry can return — lucide glyphs and our own SVGs alike. */
export type ToolIcon = ComponentType<{ className?: string }>;

// Map a tool's stored icon name to its component. Shared by the patient dock,
// the home tool dock, the session tools panel and the catalogue cards so every
// surface renders an adopted tool with the same glyph.
export const ICON_REGISTRY: Record<string, ToolIcon> = {
    Users,
    Boxes,
    Network,
    Brain,
    Heart,
    Sparkles,
    CalendarDays,
    Receipt,
    Shapes,
    Puzzle,
    Video,
    // EMDR: the eyes following the dot.
    Eye,
    // Constellation work has its own mark: three nodes linked into a triangle.
    Constellation: ConstellationIcon,
    // So does meditation: a figure sitting, not a waveform or a flower.
    Meditation: MeditationIcon,
};

export function iconFor(name?: string | null): ToolIcon {
    return (name && ICON_REGISTRY[name]) || Wrench;
}
